import { createSelector } from 'reselect';
import Constants from './constants';
import AppConfig from '../../config/AppConfig';

const stateSelector = state => state[Constants.MODULE_NAME];

const emailSelector = createSelector(stateSelector, state => state.email);
const isLoggedSelector = createSelector(emailSelector, email => Boolean(email));
const isProSelector = createSelector(stateSelector, state => state.isPro);
const isAdminSelector = createSelector(stateSelector, state => state.isAdmin);
const firstNameSelector = createSelector(stateSelector, state => state.firstName);
const fullNameSelector = createSelector(stateSelector, state => `${state.firstName} ${state.lastName}`);
const proBalanceSelector = createSelector(stateSelector, state => state.proBalance);
const isOrganizationActive = createSelector(stateSelector, state => state.isActiveOrg);
const usernameSelector = createSelector(stateSelector, state => state.username);
const shouldDisplayRenewalBanner = createSelector(stateSelector, state => state.shouldDisplayRenewalBanner);
const shouldDisplayRenewalWithChangedPriceBanner = createSelector(
  stateSelector,
  state => state.shouldDisplayRenewalWithChangedPriceBanner,
);
const shouldDisplayPasswordExpireBanner = createSelector(
  stateSelector,
  state => state.shouldDisplayPasswordExpireBanner,
);
const shouldDisplaySiDocsBanner = createSelector(stateSelector, state => state.shouldDisplaySiDocsBanner);
const hasBannerSelector = createSelector(
  shouldDisplayRenewalBanner,
  shouldDisplayPasswordExpireBanner,
  shouldDisplaySiDocsBanner,
  (displayRenewalBanner, displayPasswordExpireBanner, displaySiDocsBanner) => {
    return displayRenewalBanner || displayPasswordExpireBanner || displaySiDocsBanner;
  },
);

export const UserSelectors = {
  stateSelector,
  emailSelector,
  firstNameSelector,
  fullNameSelector,
  proBalanceSelector,
  isOrganizationActive,
  isLoggedSelector,
  isProSelector,
  isAdminSelector,
  usernameSelector,
  shouldDisplayRenewalBanner,
  shouldDisplayRenewalWithChangedPriceBanner,
  hasBannerSelector,
  shouldDisplaySiDocsBanner,
  shouldDisplayPasswordExpireBanner,
};
